<template>
    <div class="product-wrapper">
        <div class="offer product">
            <div class="product-header"
                 :class="{'filled': discountList.length }"
            >
                <div class="network">
                    <div class="selected-net">
                        <img :src="providerImageUrl" :alt="offer.provider.name" class="img-fluid"/>

                        <div class="contract-duration">
                            {{ $filters.pluralize(offer.subscription.duration, ['maand', 'maanden']) }}
                        </div>
                    </div>
                </div>

                <div v-if="!isSimOnly" class="discount-overview">
                    <div v-if="this.offer.discounts.client_discount" class="child">
                        <div>Klantvoordeel</div>

                        <div class="discount-price">
                            {{ currencySymbol }}
                            <span>
                                {{ $filters.formatDecimals(this.offer.discounts.client_discount) }}
                            </span>
                        </div>
                    </div>

                    <div class="child total" v-if="totalDiscount">
                        <div>Totale korting</div>

                        <div class="discount-price">
                            {{ currencySymbol }}
                            <span>
                                {{ $filters.formatDecimals(totalDiscount) }}
                            </span>
                        </div>
                    </div>
                </div>
            </div>

            <div :class="['product-preview', {'simonly': isSimOnly}]">
                <div class="product-details-wrap">
                    <div class="product-image" :class="{'single': !shouldShowPromoText}">
                        <a :href="offer.url">
                            <img v-if="offer.image" :src="offer.image.thumb" class="product-display" :alt="offer.device.display_name">
                            <img v-else src="/images/no-image.jpg" class="product-display" :alt="offer.device.display_name">
                        </a>
                    </div>

                    <div v-if="shouldShowPromoText" class="product-details">
                        <div class="product-details-item"
                             :class="[{'box-hidden': !offer.promo_text_1}]"
                             v-html="offer.promo_text_1"
                        />

                        <div class="product-details-item"
                             :class="{'box-hidden': !offer.promo_text_2}"
                             v-html="offer.promo_text_2"
                        />
                    </div>
                </div>

                <div class="product-title" :title="offer.device.display_name">
                    {{ offer.device.display_name }}
                </div>
            </div>

            <div :class="['offer-preview', {'simonly': isSimOnly}]">
                <div class="offer-details availability-in-stock">
                    <div class="under-line-color">
                        <div class="under-last">
                            <div class="offer single-offer">
                                <div>
                                    {{ offer.subscription_data.bundle_text_1 }}

                                    <span v-if="offer.subscription_data.bundle_text_2">
                                        + {{ offer.subscription_data.bundle_text_2 }}
                                    </span>
                                </div>

                                <div class="bundle-text text-truncate">
                                    {{ offer.subscription_data.bundle_text_3 }}
                                </div>
                            </div>

                            <div :class="['price', {'simonly': isSimOnly}]">
                                <div v-if="!isSimOnly">
                                    <div class="price-amount">
                                        <div v-if="oneTimePrice >= 0" class="price-text">eenmalig</div>
                                        <div v-else class="price-text">cashback</div>

                                        <div class="price-value">
                                            {{ $filters.formatDecimals(Math.abs(oneTimePrice)) }}
                                        </div>
                                    </div>
                                </div>

                                <div>
                                    <div class="price-amount">
                                        <div class="price-text">per maand</div>
                                        <div class="price-value">
                                            {{ $filters.formatDecimals(totalPerMonth) }}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="btn-order-wrap">
                <div class="btn-order"
                     @mouseover="isHovering = true"
                     @mouseleave="isHovering = false"
                     :class="[isHovering ? `content-${lowercaseProvider}` : '']"
                >
                    <a :href="offer.url">
                        Bekijk
                    </a>
                </div>
            </div>
        </div>

        <ilt-table
            v-if="isMobile && !isSimOnly && !offer.family.is_business"
            :offer="offer"
            :show-offer-name="false"
        />
    </div>
</template>

<script>
import IltTable from "./IltTable";
import {useOneTimePrice} from "../composables/oneTimePrice";
import {useTotalPerMonth} from "../composables/totalPerMonth";

export default {
    components: {
        IltTable
    },

    props: {
        offer: {
            type: Object,
            required: true
        }
    },

    data() {
        return {
            isHovering: false
        }
    },

    computed: {
        lowercaseProvider() {
            return this.$filters.lowerCase(this.offer.provider.name)
        },

        isSimOnly() {
            return !this.offer.subscription.has_device
        },

        shouldShowPromoText() {
            return this.offer.promo_text_1 || this.offer.promo_text_2
        },

        discountList() {
            return [
                parseFloat(this.offer.discounts.device_discount),
                parseFloat(this.offer.discounts.subscription_discount),
                parseFloat(this.offer.discounts.client_discount),
                parseFloat(this.offer.discounts.cash_back_discount),
                parseFloat(this.offer.discounts.save_offer_discount)
            ].filter(el => el)
        },

        totalDiscount() {
            return this.discountList.reduce((sum, value) => sum + value, 0)
        },

        oneTimePrice() {
            return useOneTimePrice(this.offer)
        },

        totalPerMonth() {
            return useTotalPerMonth(this.offer, null, this.offer.discount_price)
        },

        providerImageUrl() {
            if (this.offer.family.is_business) {
                return `/images/providers/business/${this.lowercaseProvider}.png`
            }

            return `/images/providers/${this.lowercaseProvider}.png`
        }
    },
}
</script>
